<template>
  <teleport to="body">
    <div class="fixed inset-0 flex items-start justify-center pt-[36px] px-6 z-[2000] pointer-events-none">
      <div class="glass-strong rounded-xl p-4 w-full max-w-5xl mx-4 pointer-events-auto">
        <div class="flex items-center justify-between mb-2">
          <div class="flex items-center gap-3">
            <h3 class="text-base font-bold text-white whitespace-nowrap">
              Test<span class="italic">Drive</span> Roadmap
            </h3>
            <p class="text-slate-400 text-xs">
              {{ make }} • {{ model }} — <span class="font-mono">{{ serial }}</span>
            </p>
          </div>
          <div class="flex items-center gap-3">
            <span class="text-slate-300 text-xs">
              Status: <span class="text-white font-medium">{{ statusLabel }}</span>
            </span>
            <button
              class="px-2 py-1 rounded bg-slate-800 border border-slate-700 text-white text-[11px]"
              @click="$emit('close')"
            >
              Close
            </button>
          </div>
        </div>

        <!-- Reuse lifecycle with icons + animated progress -->
        <EquipmentJourney :status="status" :has-return-label="hasReturnLabel" />
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onBeforeUnmount } from 'vue'
import EquipmentJourney from '@/components/EquipmentJourney.vue'
const props = defineProps<{
  make: string
  model: string
  serial: string
  status?: string
  hasReturnLabel?: boolean
}>()
defineEmits(['close'])

const currentStatus = ref<string>((props.status || 'reserved').toLowerCase())
function handleRoadmapEvent(evt: Event) {
  try {
    const anyEvt: any = evt
    const next: string | undefined = anyEvt?.detail?.status
    if (typeof next === 'string') {
      currentStatus.value = String(next).toLowerCase()
    }
  } catch {}
}
onMounted(() => {
  try {
    window.addEventListener('roadmap-status', handleRoadmapEvent)
  } catch {}
})
onBeforeUnmount(() => {
  try {
    window.removeEventListener('roadmap-status', handleRoadmapEvent)
  } catch {}
})

const status = computed(() => currentStatus.value)

const statusLabels: Record<string, string> = {
  reserved: 'Reserved',
  checked_out: 'Checked Out',
  outbound_label: 'Outbound Label',
  carrier_accepted: 'Carrier Accepted',
  outbound_in_transit: 'In Transit',
  out_for_delivery: 'Out for Delivery',
  with_borrower: 'With Borrower',
  return_initiated: 'Return Label Created',
  return_carrier_scan: 'Return Carrier Scan',
  return_in_transit: 'Return In Transit',
  received: 'Received at Warehouse',
  checked_in: 'Checked In',
}
const statusLabel = computed(() => statusLabels[status.value] || 'Reserved')
</script>

<style scoped></style>
